import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

/**
 * Highlights all occurrences of search tokens within a string by wrapping them in <strong> tags.
 * Tokens are split by whitespace. Matching is case-insensitive.
 *
 * Usage: text | highlightSearch:'pitt county'
 */
@Pipe({
  name: 'highlightSearch',
  standalone: false
})
export class HighlightSearchPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(text: string, search: string): SafeHtml {
    if (!text || !search?.trim()) {
      return this.sanitizer.bypassSecurityTrustHtml(text || '');
    }

    // Escape any HTML in the source text first to prevent XSS
    const safe = text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

    const tokens = search.trim().split(/\s+/).filter(t => t.length > 0);
    if (tokens.length === 0) return this.sanitizer.bypassSecurityTrustHtml(safe);

    // Escape regex special chars in each token, then join with alternation
    const escaped = tokens.map(t => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    const regex = new RegExp(`(${escaped.join('|')})`, 'gi');
    const highlighted = safe.replace(regex, '<strong>$1</strong>');
    return this.sanitizer.bypassSecurityTrustHtml(highlighted);
  }
}
